"use strict";
import { TamaguiProvider as OGTamaguiProvider } from "tamagui";
import { useIsDarkMode } from "theme/components/ThemeToggle";
import config from "ui/src/tamagui.config";
export function TamaguiProvider({ children, ...rest }) {
  const darkMode = useIsDarkMode();
  return <OGTamaguiProvider config={config} defaultTheme={darkMode ? "dark" : "light"} {...rest}>{children}</OGTamaguiProvider>;
}
